import createCache from '@emotion/cache'
import { CacheProvider } from '@emotion/react'
import { createRoot } from 'react-dom/client'

// Roboto is MUI's default family and the Plotly chart font. Bundled rather than
// linked from fonts.googleapis.com, which is blocked in China and held every
// cold load of www.adapetcn.com for ~5 s. Same weights the Google link asked for.
import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'
// Open Sans is Plotly's default font ('"Open Sans", verdana, arial'): every chart
// without its own font.family (AGP, daily trend, weight tooltip) renders in it.
// Same weights the old Google link loaded (it had no 400). Faces only download
// when a chart actually draws text in them.
import '@fontsource/open-sans/300.css'
import '@fontsource/open-sans/500.css'
import '@fontsource/open-sans/600.css'
import '@fontsource/open-sans/700.css'

import App from './App'

// Create emotion cache with a specific key to ensure consistent CSS injection
const emotionCache = createCache({
  key: 'vetpo',
  prepend: true, // This ensures emotion styles are injected before MUI styles
})

const container = document.getElementById('root')
if (!container) {
  throw new Error('No container found')
}
const root = createRoot(container)

root.render(
  <CacheProvider value={emotionCache}>
    <App />
  </CacheProvider>,
)
